<div [ngClass]="{'mobile-hidden': extension}">
  <app-header></app-header>
</div>
<router-outlet></router-outlet>
